import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import css from './ListingPage.module.css';

/**
 * A sticky call-to-action card shown below the OrderPanel that invites
 * potential renters to reach out to the listing host before booking.
 *
 * @component
 * @param {Object} props
 * @param {string} props.authorDisplayName - First name (or full name) of the host
 * @param {Function} props.onContactUser - Callback that opens the inquiry modal
 */
const SectionContactHost = ({ authorDisplayName, onContactUser }) => {
  if (!authorDisplayName) {
    return null;
  }

  return (
    <div className={css.contactHostCard}>
      <p className={css.contactHostHeading}>
        <FormattedMessage
          id="ListingPage.contactHostHeading"
          values={{ name: authorDisplayName }}
        />
      </p>
      <p className={css.contactHostBody}>
        <FormattedMessage
          id="ListingPage.contactHostBody"
          values={{ name: authorDisplayName }}
        />
      </p>
      <button
        className={css.contactHostButton}
        onClick={onContactUser}
        type="button"
      >
        <FormattedMessage
          id="ListingPage.contactHostButton"
          values={{ name: authorDisplayName }}
        />
      </button>
    </div>
  );
};

export default SectionContactHost;
